/* ============================================================
   Gift Collection – interactivity
   - Card swatch selection -> active variant
   - Add to cart -> theme slide cart (ajaxProduct:added)
   - Quick-View bottom sheet (open via name/image only)
   - Infinite scroll (AJAX pagination) with skeletons
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.gcInit === '1') return;
    root.dataset.gcInit = '1';

    var moneyFormat = root.getAttribute('data-money-format') || '€{{amount}}';

    // Letzte besuchte Collection für die PDP-"Zurück"-Pill merken (inkl. aktivem Tag-Filter)
    try {
      var colTitle = root.getAttribute('data-gc-col-title') || '';
      if (/^all products$/i.test(colTitle)) colTitle = '';
      sessionStorage.setItem('sp:lastCollection', JSON.stringify({
        url: location.pathname,
        handle: (location.pathname.match(/^\/collections\/([^\/]+)/) || [])[1] || '',
        title: colTitle || null
      }));
    } catch (e) {}

    // ============================================================
    // Layout + Feature-Toggles. Priorität: URL-Override > GrowthBook-Experiment > Editor-Default.
    // GrowthBook lädt async (auto-Bundle); Exposures werden vom Bundle automatisch nach
    // dataLayer (event "experiment_viewed") + GA4/gtag gefeuert -> sauber via GTM/Stape auswertbar.
    // ============================================================
    var gcParams = new URLSearchParams(location.search);
    var GC_LAYOUTS = ['editorial', 'compact', 'grid'];
    var showSubtitle = root.getAttribute('data-gc-show-subtitle') !== 'false';

    function setLayout(lay) {
      if (GC_LAYOUTS.indexOf(lay) === -1) return;
      root.classList.remove('gc--layout-editorial', 'gc--layout-compact', 'gc--layout-grid');
      root.classList.add('gc--layout-' + lay);
      root.setAttribute('data-gc-layout', lay);
    }
    function applySubtitle(show) {
      showSubtitle = !!show;
      root.classList.toggle('gc-hide-subtitle', !show);
    }

    // 1) URL-Overrides (QA / erzwungene Buckets) — gewinnen immer
    var urlClick = (gcParams.get('gcclick') || '').toLowerCase();
    var hasUrlClick = urlClick === 'pdp' || urlClick === 'modal';
    var clickMode = hasUrlClick ? urlClick : 'pdp'; // Test gift-collection-click beendet 23.10.2026: Produktseite gewinnt
    var urlLayout = (gcParams.get('gclayout') || '').toLowerCase();
    var hasUrlLayout = GC_LAYOUTS.indexOf(urlLayout) > -1;
    if (hasUrlLayout) setLayout(urlLayout);

    var urlSub = gcParams.get('subtitle');
    var hasUrlSub = urlSub != null;
    if (hasUrlSub) {
      urlSub = urlSub.toLowerCase();
      if (['off', '0', 'false', 'hide', 'no'].indexOf(urlSub) > -1) showSubtitle = false;
      else if (['on', '1', 'true', 'show', 'yes'].indexOf(urlSub) > -1) showSubtitle = true;
    }
    root.classList.toggle('gc-hide-subtitle', !showSubtitle);

    // 2) GrowthBook-Flags (als Experiment anlegen, damit Exposures feuern):
    //      gift-collection-layout       -> "editorial" | "compact" | "grid"
    //      gift-collection-subtitle     -> boolean  (Produkt-Subtitle ein/aus)
    //      gift-collection-reviews-bar  -> boolean  (Judge.me Review-Leiste ein/aus)
    //      gift-collection-cta-style    -> "solid" | "outline"
    // Das auto-Bundle verarbeitet `growthbook_queue` NICHT -> wie die übrigen Store-Skripte
    // auf gb.ready pollen (window._growthbook|growthbook|gb). getFeatureValue feuert dabei
    // die Exposure (experiment_viewed -> dataLayer -> GA4) für experiment-backed Flags.
    (function () {
      function applyFlags(gb) {
        if (!gb || typeof gb.getFeatureValue !== 'function') return;
        if (!hasUrlLayout) {
          var lay = gb.getFeatureValue('gift-collection-layout', null);
          if (typeof lay === 'string') setLayout(lay.toLowerCase());
        }
        if (!hasUrlSub) {
          var sub = gb.getFeatureValue('gift-collection-subtitle', null);
          if (sub !== null && sub !== undefined) applySubtitle(!!sub);
        }
        var rev = gb.getFeatureValue('gift-collection-reviews-bar', null);
        if (rev !== null && rev !== undefined) root.classList.toggle('gc-hide-reviews', !rev);
        if (!hasUrlClick) {
          var ck = gb.getFeatureValue('gift-collection-click', null);
          if (ck === 'pdp' || ck === 'modal') clickMode = ck;
        }
        var cta = gb.getFeatureValue('gift-collection-cta-style', null);
        if (typeof cta === 'string') root.classList.toggle('gc-cta-outline', cta.toLowerCase() === 'outline');
      }
      var tries = 0;
      (function poll() {
        var gb = window._growthbook || window.growthbook || window.gb;
        if (gb && gb.ready) { applyFlags(gb); return; }
        if (tries++ < 30) setTimeout(poll, 100);
      })();
    })();

    // Promo / Gutschein activation — applied silently in the background (no visible redirect)
    (function () {
      var promoEl = root.querySelector('[data-gc-promo-code]');
      var code = promoEl ? promoEl.getAttribute('data-gc-promo-code') : '';
      if (!code) return;

      function discountUrl(redirectTo) {
        return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectTo || '/cart.js');
      }
      // no-JS fallback: full redirect that returns to the current view with all params
      promoEl.setAttribute('href', discountUrl(location.pathname + location.search));

      function applyInBackground() {
        // 1) apply the discount code, 2) re-fetch the cart, 3) tell the cart UI (theme + AMP slide cart) to re-render
        return fetch(discountUrl('/cart.js'), { credentials: 'same-origin' })
          .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:build'));
            } catch (e) {}
            return cart;
          });
      }

      var cta = promoEl.querySelector('.gc-promo__cta');
      promoEl.addEventListener('click', function (e) {
        e.preventDefault();
        if (cta) cta.textContent = '…';
        applyInBackground()
          .then(function () { if (cta) cta.textContent = '✓ Aktiviert'; })
          .catch(function () { window.location.href = discountUrl(location.pathname + location.search); });
      });

      // ?promo=on -> activate silently, then strip the param from the URL (no reload)
      var params = new URLSearchParams(location.search);
      var pv = (params.get('promo') || '').toLowerCase();
      if (['on', '1', 'true', 'yes', 'activate'].indexOf(pv) > -1) {
        applyInBackground().then(function () {
          params.delete('promo');
          var clean = location.pathname + (params.toString() ? '?' + params.toString() : '');
          if (history.replaceState) history.replaceState(null, '', clean);
          if (cta) cta.textContent = '✓ Aktiviert';
        }).catch(function () {});
      }
    })();

    function formatMoney(cents) {
      var withDecimals = (cents / 100).toFixed(2).replace('.', ',');
      var noDecimals = String(Math.round(cents / 100));
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
        .replace(/<[^>]*>/g, '')
        .trim() || ('€' + withDecimals);
    }
    function priceHTML(cents) {
      return formatMoney(cents).replace(/,(\d+)/, '<sup class="gc-cents">$1</sup>');
    }

    function getData(id) {
      var el = root.querySelector('script[data-gc-product="' + id + '"]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    /* ---------------- Slide cart ---------------- */
    function addToCart(variantId, quantity, btn, extraItems) {
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      var json = extraItems && extraItems.length;
      var body = json
        ? JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }].concat(extraItems) })
        : 'id=' + encodeURIComponent(variantId) + '&quantity=' + encodeURIComponent(quantity || 1);

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': json ? 'application/json' : 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status && data.status !== 200) {
            if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
            flash(btn, 'Nicht verfügbar');
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: btn }
          }));
          closeQv();
          openSlideCart();
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          flash(btn, 'Fehler – erneut versuchen');
        });
    }

    function flash(btn, msg) {
      if (!btn) return;
      var html = btn.innerHTML;
      btn.innerHTML = msg;
      setTimeout(function () { btn.innerHTML = html; }, 1800);
    }

    // Open the store's slide cart (AMP cart app). Its trigger is the header cart
    // link .js-drawer-open-cart; on open AMP re-fetches /cart.js and shows the item.
    function openSlideCart() {
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
      if (trigger) { trigger.click(); }
    }

    /* ---------------- Per-card binding (initial + appended) ---------------- */
    function bindCard(card) {
      if (card.dataset.gcBound === '1') return;
      card.dataset.gcBound = '1';

      var media = card.querySelector('.gc-card__media');
      var img = card.querySelector('.gc-card__media img');
      var priceEl = card.querySelector('.gc-card__price [data-gc-price]');

      // image shimmer -> loaded
      if (img) {
        if (img.complete && img.naturalWidth) { media.classList.add('is-loaded'); }
        else { img.addEventListener('load', function () { media.classList.add('is-loaded'); }); }
      }

      // swatches select variant
      card.querySelectorAll('.gc-swatch[data-variant-id]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          card.querySelectorAll('.gc-swatch').forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          card.setAttribute('data-selected-variant', sw.getAttribute('data-variant-id'));
          var vurl = sw.getAttribute('data-variant-url');
          if (vurl) { card.querySelectorAll('[data-gc-pdp]').forEach(function (a) { a.setAttribute('href', vurl); }); }
          var newImg = sw.getAttribute('data-variant-image');
          if (newImg && img) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.style.opacity = '.4';
            img.onload = function () { img.style.opacity = '1'; };
            img.src = newImg;
          }
          var price = sw.getAttribute('data-variant-price');
          if (price && priceEl) { priceEl.innerHTML = priceHTML(parseInt(price, 10)); }
        });
      });

      // quick-view triggers (name / image / +N) – im Test-Modus "pdp" direkt auf die Produktseite
      card.querySelectorAll('[data-gc-quickview]').forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var pid = trigger.getAttribute('data-gc-quickview');
          if (clickMode === 'pdp') { var dd = getData(pid); if (dd && dd.url) { window.location.href = dd.url; return; } }
          openQv(pid);
        });
      });

      // add to cart
      card.querySelectorAll('[data-gc-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var variantId = card.getAttribute('data-selected-variant') || card.getAttribute('data-default-variant');
          if (variantId) addToCart(variantId, 1, btn);
        });
      });
    }

    /* ---------------- Quick-View ---------------- */
    var qv = root.querySelector('.gc-qv');
    var state = { data: null, selected: {}, variant: null, qty: 1 };

    var el = {
      image: root.querySelector('[data-qv-image]'),
      hero: root.querySelector('[data-qv-hero]'),
      gallery: root.querySelector('[data-qv-gallery]'),
      thumbs: root.querySelector('[data-qv-thumbs]'),
      thumbsNext: root.querySelector('[data-qv-thumbs-next]'),
      title: root.querySelector('[data-qv-title]'),
      sub: root.querySelector('[data-qv-sub]'),
      price: root.querySelector('[data-qv-price]'),
      colorLabel: root.querySelector('[data-qv-color-label]'),
      colorValue: root.querySelector('[data-qv-color-value]'),
      swatches: root.querySelector('[data-qv-swatches]'),
      options: root.querySelector('[data-qv-options]'),
      qtyInput: root.querySelector('[data-qv-qty]'),
      stock: root.querySelector('[data-qv-stock]'),
      stockText: root.querySelector('[data-qv-stock-text]'),
      details: root.querySelector('[data-qv-details]'),
      add: root.querySelector('[data-qv-add]'),
      addLabel: root.querySelector('[data-qv-add-label]'),
      addPrice: root.querySelector('[data-qv-add-price]')
    };

    function matchVariant() {
      var d = state.data;
      if (!d) return null;
      var v = d.variants.find(function (vr) {
        return vr.options.every(function (opt, i) { return state.selected[i] === opt; });
      });
      return v || d.variants.find(function (vr) { return vr.available; }) || d.variants[0];
    }

    function setMainImage(src, makeThumbActive) {
      if (src && el.image) el.image.src = src;
      if (makeThumbActive && el.thumbs) {
        el.thumbs.querySelectorAll('.gc-qv__thumb').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-src') === src);
        });
        var active = el.thumbs.querySelector('.gc-qv__thumb.is-active');
        if (active) active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }

    /* ---- Simple Pledge: Mengenauswahl 1/2/3 + Geschenkverpackung (wie auf der Produktseite) ---- */
    var spQv = (function () {
      var box = root.querySelector('[data-qv-qty3]'), wrapEl = root.querySelector('[data-qv-wrap]');
      var wrapIn = root.querySelector('[data-qv-wrap-input]');
      var cfg = {}; try { cfg = JSON.parse(root.querySelector('[data-qv-sp-config]').textContent); } catch (e) {}
      var types = (cfg.qtyTypes || []).map(function (t) { return String(t).trim(); });
      var fmt = function (c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); };
      var endOf = function (d) { return d ? new Date(d + 'T23:59:59+01:00').getTime() : 0; };
      var on = false, type = '';
      function duo() { return cfg.duoOn && cfg.duoCode && type === cfg.duoType && Date.now() <= endOf(cfg.duoUntil); }
      function calc(q, p) {
        var sum = p * q, off = 0;
        if (duo() && q === 2) off = Math.round(p / 2);
        if (duo() && q === 3) off = cfg.trioOff || Math.round(p / 2);   // 22.10.2026: ohne Trio-Code (DUO) gilt auch bei 3 Stück ein Teil −50 %
        return { sum: sum, total: sum - off, off: off };
      }
      function noun(q) {
        if (/Seil/.test(type)) return q === 1 ? 'Armband' : 'Armbänder';
        if (/Armreif/.test(type)) return q === 1 ? 'Armreif' : 'Armreife';
        return 'Stück';
      }
      function setup(d) {
        type = (d && d.type) || '';
        on = !!(box && types.indexOf(type) > -1);
        if (box) box.hidden = !on;
        if (qv) qv.classList.toggle('has-qty3', on);
        if (wrapIn) wrapIn.checked = false;
        if (on) select(1);
      }
      function select(q) {
        state.qty = q;
        if (el.qtyInput) el.qtyInput.value = q;
        box.querySelectorAll('[data-q]').forEach(function (b) { var is = parseInt(b.getAttribute('data-q'), 10) === q; b.classList.toggle('is-on', is); b.setAttribute('aria-checked', is ? 'true' : 'false'); });
        render();
      }
      function render() {
        if (!state.variant) return;
        var p = state.variant.price;
        if (on) box.querySelectorAll('[data-q]').forEach(function (b) {
          var q = parseInt(b.getAttribute('data-q'), 10), k = calc(q, p), note = '', badge = '';
          b.querySelector('[data-q-title]').textContent = q + ' ' + noun(q);
          b.querySelector('[data-q-price]').textContent = fmt(k.total);
          var shipFrom2 = cfg.shipFrom2 && (!cfg.shipFrom2Until || Date.now() <= endOf(cfg.shipFrom2Until));
          var duo3 = duo() && !cfg.trioOff;   // DUO ohne Trio: Duo-Code gewinnt, kein Gratis-Armreif
          if (q === 2) { if (k.off) { badge = '−50 % aufs 2.'; note = 'statt ' + fmt(k.sum); } else if (k.total >= cfg.ship || shipFrom2) note = 'Gratis-Versand'; }
          if (q === 3) { if (!duo3 && cfg.gift && k.sum >= cfg.gift) { badge = '+ Geschenk'; note = 'Armreif gratis dazu'; } else if (k.off) { if (duo3) badge = '−50 % aufs 2.'; note = 'statt ' + fmt(k.sum); } }
          var bd = b.querySelector('[data-q-badge]'); bd.hidden = !badge; bd.textContent = badge;
          b.querySelector('[data-q-note]').textContent = note;
        });
        var total = on ? calc(state.qty, p).total : p * state.qty;
        if (wrapIn && wrapIn.checked) total += cfg.wrapPrice || 0;
        if (el.addPrice) el.addPrice.textContent = formatMoney(total);
      }
      if (box) box.addEventListener('click', function (e) { var b = e.target.closest('[data-q]'); if (b) select(parseInt(b.getAttribute('data-q'), 10)); });
      if (wrapIn) wrapIn.addEventListener('change', render);
      function extras() {
        if (!wrapIn || !wrapIn.checked || !cfg.wrapVariant) return Promise.resolve([]);
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          .then(function (c) { return c.items.some(function (i) { return i.variant_id === cfg.wrapVariant; }) ? [] : [{ id: cfg.wrapVariant, quantity: 1 }]; })
          .catch(function () { return [{ id: cfg.wrapVariant, quantity: 1 }]; });
      }
      return { setup: setup, render: render, extras: extras };
    })();

    function renderVariant() {
      var v = matchVariant();
      state.variant = v;
      if (!v) return;
      if (el.price) el.price.innerHTML = priceHTML(v.price);
      if (el.addPrice) el.addPrice.textContent = formatMoney(v.price * state.qty);
      if (v.image) setMainImage(v.image, true);

      if (state.data.colorIndex > -1 && el.colorValue) {
        el.colorValue.textContent = state.selected[state.data.colorIndex] || '';
      }

      var avail = v.available;
      if (el.add) el.add.disabled = !avail;
      if (el.addLabel) el.addLabel.textContent = avail ? 'In den Warenkorb – ' : 'Ausverkauft';
      spQv.render();
      if (el.stock) {
        el.stock.classList.toggle('is-out', !avail);
        if (el.stockText) el.stockText.textContent = avail
          ? (state.data.stockText || 'Auf Lager – in 1-3 Werktagen bei dir')
          : 'Aktuell ausverkauft';
      }
    }

    function renderOptions() {
      var d = state.data;
      if (el.swatches) el.swatches.innerHTML = '';
      if (el.options) el.options.innerHTML = '';
      state.selected = {};
      var startV = d.variants.filter(function (v) { return String(v.id) === String(state.startVariant) && v.available; })[0]
        || d.variants.filter(function (v) { return v.available; })[0] || d.variants[0];
      // Wert ist wählbar, wenn es mit den übrigen Start-Optionen eine verfügbare Variante gibt
      function valueAvailable(oi, val) {
        return d.variants.some(function (v) { return v.available && v.options[oi] === val && v.options.every(function (o, j) { return j === oi || o === startV.options[j]; }); });
      }

      d.optionNames.forEach(function (name, oi) {
        var values = [];
        d.variants.forEach(function (v) { if (values.indexOf(v.options[oi]) === -1) values.push(v.options[oi]); });
        state.selected[oi] = startV.options[oi];
        if (values.length <= 1) return;

        if (oi === d.colorIndex && el.swatches) {
          values.forEach(function (val) {
            var color = (d.colors || []).find(function (c) { return c.value === val; }) || {};
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'gc-swatch';
            b.title = val;
            b.style.background = color.bg || '#ccc';
            b.style.backgroundSize = 'cover';
            b.style.backgroundPosition = 'center';
            if (!valueAvailable(oi, val)) { b.classList.add('is-soldout'); b.title = val + ' – ausverkauft'; b.setAttribute('aria-label', val + ' – ausverkauft'); }
            if (val === startV.options[oi]) b.classList.add('is-active');
            b.addEventListener('click', function () {
              state.selected[oi] = val;
              el.swatches.querySelectorAll('.gc-swatch').forEach(function (s) { s.classList.remove('is-active'); });
              b.classList.add('is-active');
              renderVariant();
            });
            el.swatches.appendChild(b);
          });

        } else if (el.options) {
          var label = document.createElement('div');
          label.className = 'gc-qv__color-label';
          label.textContent = name;
          var row = document.createElement('div');
          row.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin:0 0 14px;';
          values.forEach(function (val) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = val;
            if (!valueAvailable(oi, val)) { btn.style.opacity = '.45'; btn.style.textDecoration = 'line-through'; }
            if (val === startV.options[oi]) btn.setAttribute('data-start', '1');
            btn.style.cssText = 'padding:9px 15px;border-radius:9999px;border:1px solid rgba(0,0,0,.15);background:#fff;cursor:pointer;font-size:13px;';
            btn.addEventListener('click', function () {
              state.selected[oi] = val;
              row.querySelectorAll('button').forEach(function (x) { x.style.borderColor = 'rgba(0,0,0,.15)'; x.style.background = '#fff'; });
              btn.style.borderColor = 'var(--gc-accent)';
              btn.style.background = 'color-mix(in srgb, var(--gc-accent) 10%, #fff)';
              renderVariant();
            });
            row.appendChild(btn);
          });
          var startBtn = row.querySelector('button[data-start]') || row.querySelector('button');
          startBtn.style.borderColor = 'var(--gc-accent)';
          startBtn.style.background = 'color-mix(in srgb, var(--gc-accent) 10%, #fff)';
          el.options.appendChild(label);
          el.options.appendChild(row);
        }
      });

      if (el.colorLabel) el.colorLabel.style.display = (d.colorIndex > -1) ? '' : 'none';
    }

    function updateGalleryAffordance() {
      if (!el.thumbs || !el.gallery) return;
      var scrollable = el.thumbs.scrollWidth > el.thumbs.clientWidth + 4;
      var atEnd = el.thumbs.scrollLeft + el.thumbs.clientWidth >= el.thumbs.scrollWidth - 4;
      el.gallery.classList.toggle('is-scrollable', scrollable);
      el.gallery.classList.toggle('is-end', !scrollable || atEnd);
    }

    function renderThumbs() {
      if (!el.thumbs) return;
      el.thumbs.innerHTML = '';
      var media = state.data.media || [];
      media.forEach(function (src, i) {
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'gc-qv__thumb';
        t.setAttribute('data-src', src);
        t.setAttribute('data-index', i);
        t.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
        t.addEventListener('click', function () { state.mediaIndex = i; setMainImage(src, true); });
        el.thumbs.appendChild(t);
      });
      var first = el.thumbs.querySelector('.gc-qv__thumb');
      if (first) first.classList.add('is-active');
      if (el.thumbs) el.thumbs.scrollLeft = 0;
      // affordance after layout settles
      requestAnimationFrame(updateGalleryAffordance);
      setTimeout(updateGalleryAffordance, 150);
    }

    function openQv(id) {
      var d = getData(id);
      if (!d || !qv) return;
      state.data = d;
      var cardEl = root.querySelector('.gc-card[data-product-id="' + id + '"]');
      state.startVariant = cardEl ? (cardEl.getAttribute('data-selected-variant') || cardEl.getAttribute('data-default-variant')) : null;
      state.qty = 1;
      state.mediaIndex = 0;
      if (el.qtyInput) el.qtyInput.value = '1';
      if (el.title) el.title.textContent = d.title;
      if (el.sub) {
        el.sub.textContent = d.subtitle || '';
        el.sub.style.display = (showSubtitle && d.subtitle) ? '' : 'none';
      }
      if (el.details) el.details.href = d.url;
      setMainImage((d.media && d.media[0]) || '', false);
      renderThumbs();
      spQv.setup(d);
      renderOptions();
      renderVariant();
      root.classList.add('is-qv-open');
      document.body.style.overflow = 'hidden';
    }

    function closeQv() {
      if (!root.classList.contains('is-qv-open')) return;
      root.classList.remove('is-qv-open');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-qv-close]').forEach(function (c) { c.addEventListener('click', closeQv); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQv(); });

    if (el.qtyInput) {
      root.querySelectorAll('[data-qv-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var delta = parseInt(b.getAttribute('data-qv-qty-step'), 10);
          state.qty = Math.max(1, (parseInt(el.qtyInput.value, 10) || 1) + delta);
          el.qtyInput.value = state.qty;
          if (state.variant && el.addPrice) el.addPrice.textContent = formatMoney(state.variant.price * state.qty);
        });
      });
      el.qtyInput.addEventListener('change', function () {
        state.qty = Math.max(1, parseInt(el.qtyInput.value, 10) || 1);
        el.qtyInput.value = state.qty;
        if (state.variant && el.addPrice) el.addPrice.textContent = formatMoney(state.variant.price * state.qty);
      });
    }

    if (el.add) {
      el.add.addEventListener('click', function () {
        if (!state.variant || !state.variant.available) return;
        var vid = state.variant.id, q = state.qty;
        spQv.extras().then(function (ex) { addToCart(vid, q, el.add, ex); });
      });
    }

    // Gallery: horizontal scroll affordance + swipe on main image
    if (el.thumbsNext) {
      el.thumbsNext.addEventListener('click', function () {
        el.thumbs.scrollBy({ left: Math.round(el.thumbs.clientWidth * 0.7), behavior: 'smooth' });
      });
    }
    if (el.thumbs) {
      el.thumbs.addEventListener('scroll', updateGalleryAffordance, { passive: true });
    }
    if (el.hero) {
      var swipeX = 0;
      el.hero.addEventListener('touchstart', function (e) { swipeX = e.touches[0].clientX; }, { passive: true });
      el.hero.addEventListener('touchend', function (e) {
        var media = (state.data && state.data.media) || [];
        if (media.length < 2) return;
        var dx = e.changedTouches[0].clientX - swipeX;
        if (Math.abs(dx) < 40) return;
        var idx = state.mediaIndex || 0;
        idx = dx < 0 ? Math.min(media.length - 1, idx + 1) : Math.max(0, idx - 1);
        state.mediaIndex = idx;
        setMainImage(media[idx], true);
      });
    }
    window.addEventListener('resize', updateGalleryAffordance);

    /* ---------------- Reviews modal (lazy Judge.me /pages/reviews) ---------------- */
    (function () {
      var openers = root.querySelectorAll('[data-gc-reviews-open]');
      if (!openers.length) return;
      function openRev() { root.classList.add('is-rev-open'); document.body.style.overflow = 'hidden'; }
      function closeRev() { root.classList.remove('is-rev-open'); document.body.style.overflow = ''; }
      openers.forEach(function (o) { o.addEventListener('click', openRev); });
      root.querySelectorAll('[data-gc-reviews-close]').forEach(function (c) { c.addEventListener('click', closeRev); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeRev(); });
    })();

    /* ---------------- Infinite scroll ---------------- */
    var list = root.querySelector('[data-gc-list]');
    var sentinel = root.querySelector('[data-gc-sentinel]');
    var loading = false;

    function skeletonCard() {
      var sk = document.createElement('div');
      sk.className = 'gc-card gc-skeleton';
      sk.setAttribute('data-skeleton', '');
      sk.innerHTML =
        '<div class="gc-sk-media"></div>' +
        '<div class="gc-sk-body">' +
        '<div class="sk sk-title"></div>' +
        '<div class="sk sk-sub"></div>' +
        '<div class="sk sk-price"></div>' +
        '<div class="sk sk-swatches"></div>' +
        '<div class="sk sk-cta"></div>' +
        '</div>';
      return sk;
    }
    function showSkeletons(n) { for (var i = 0; i < n; i++) list.appendChild(skeletonCard()); }
    function hideSkeletons() { list.querySelectorAll('[data-skeleton]').forEach(function (s) { s.remove(); }); }

    function buildNextUrl(raw) {
      var url = new URL(raw, window.location.origin);
      url.searchParams.set('view', 'gift');
      var pt = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (pt) url.searchParams.set('preview_theme_id', pt);
      return url.toString();
    }

    function loadMore() {
      if (loading || !sentinel) return Promise.resolve();
      var next = sentinel.getAttribute('data-gc-next-url');
      if (!next) { observer.disconnect(); return Promise.resolve(); }
      loading = true;
      showSkeletons(Math.min(4, parseInt(root.getAttribute('data-gc-per-page'), 10) || 4));

      return fetch(buildNextUrl(next), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-gc-list] .gc-card');
          hideSkeletons();
          newCards.forEach(function (c) {
            var node = document.importNode(c, true);
            node.removeAttribute('data-gc-bound');
            list.appendChild(node);
            bindCard(node);
          });
          root._gcExtraPages = (root._gcExtraPages || 0) + 1;
          var ns = doc.querySelector('[data-gc-sentinel]');
          var nextUrl = ns && ns.getAttribute('data-gc-next-url');
          if (nextUrl) sentinel.setAttribute('data-gc-next-url', nextUrl);
          else { sentinel.removeAttribute('data-gc-next-url'); observer.disconnect(); }
          loading = false;
        })
        .catch(function () { hideSkeletons(); loading = false; });
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadMore();
    }, { rootMargin: '700px 0px' });
    if (sentinel && sentinel.getAttribute('data-gc-next-url')) observer.observe(sentinel);

    /* ---------------- Initial bind ---------------- */
    root.querySelectorAll('.gc-card').forEach(bindCard);

    /* ---------------- Filter pills: AJAX tag-filter of the current collection ---------------- */
    var pillsEl = root.querySelector('[data-gc-pills]');
    var filtering = false;
    if (pillsEl && list) {
      var keepView = new URLSearchParams(location.search).get('view') === 'gift';
      var stateUrl = function (path) {
        if (!keepView) return path;
        var u = new URL(path, location.origin);
        u.searchParams.set('view', 'gift');
        return u.pathname + u.search;
      };
      var applyFilter = function (href, pill) {
        if (filtering) return;
        filtering = true;
        pillsEl.querySelectorAll('.gc-pill').forEach(function (p) { p.classList.remove('is-active'); });
        if (pill) pill.classList.add('is-active');
        list.style.opacity = '.45';
        fetch(buildNextUrl(href), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nl = doc.querySelector('[data-gc-list]');
            list.innerHTML = nl ? nl.innerHTML : '<p class="gc-empty">Keine Produkte gefunden.</p>';
            list.querySelectorAll('.gc-card').forEach(function (c) { c.removeAttribute('data-gc-bound'); bindCard(c); });
            var ns = doc.querySelector('[data-gc-sentinel]');
            var nx = ns ? ns.getAttribute('data-gc-next-url') : '';
            if (sentinel) {
              if (nx) { sentinel.setAttribute('data-gc-next-url', nx); if (observer) observer.observe(sentinel); }
              else sentinel.removeAttribute('data-gc-next-url');
            }
            root._gcExtraPages = 0;
            list.style.opacity = '';
            filtering = false;
            if (history.pushState) history.pushState({ gcFilter: 1 }, '', stateUrl(href));
            var top = (list.getBoundingClientRect().top + (window.pageYOffset || 0)) - 70;
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          })
          .catch(function () { list.style.opacity = ''; filtering = false; });
      };
      pillsEl.querySelectorAll('.gc-pill').forEach(function (pill) {
        pill.addEventListener('click', function (e) { e.preventDefault(); applyFilter(pill.getAttribute('href'), pill); });
      });
      // back/forward through filters -> reload to the (now correct) URL
      window.addEventListener('popstate', function () { location.reload(); });
    }

    /* ---------------- Scroll restoration (back from PDP) ---------------- */
    (function () {
      var SKEY = 'gc:scroll:' + location.pathname;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

      function save() {
        try {
          sessionStorage.setItem(SKEY, JSON.stringify({
            y: window.pageYOffset || document.documentElement.scrollTop || 0,
            pages: 1 + (root._gcExtraPages || 0)
          }));
        } catch (e) {}
      }
      var saveTimer;
      window.addEventListener('scroll', function () { clearTimeout(saveTimer); saveTimer = setTimeout(save, 200); }, { passive: true });
      window.addEventListener('pagehide', save);

      // Only restore on real back/forward navigation
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      if (nav.type !== 'back_forward') return;

      var raw; try { raw = sessionStorage.getItem(SKEY); } catch (e) {}
      if (!raw) return;
      var saved; try { saved = JSON.parse(raw); } catch (e) { return; }
      if (!saved || !saved.y) return;

      var need = Math.min((saved.pages || 1) - 1, 30);
      function step() {
        if (need <= 0) { window.scrollTo(0, saved.y); return; }
        var s = root.querySelector('[data-gc-sentinel]');
        if (!s || !s.getAttribute('data-gc-next-url')) { window.scrollTo(0, saved.y); return; }
        need--;
        loadMore().then(function () { requestAnimationFrame(step); });
      }
      setTimeout(step, 60);
      // re-apply after images/layout settle
      setTimeout(function () { if (Math.abs((window.pageYOffset || 0) - saved.y) > 6) window.scrollTo(0, saved.y); }, 1300);
    })();
  }

  function initAll() { document.querySelectorAll('[data-gc-collection]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-gc-collection]');
    if (root) init(root);
  });
})();
